<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Copyright Page" epub:type="copyright-page">
<p class="CRT1"><span aria-label=" Page v. " epub:type="pagebreak" id="pg_v" role="doc-pagebreak">© 2002, Text by Debra Magpie Earling</span></p>
<p class="CRT">Original edition first published by BlueHen Books, a member of</p>
<p class="CRT">Penguin Putnam Inc. in New York, New York.</p>
<p class="CRT">All rights reserved. Except for brief quotations in critical articles or reviews, no part of this book may be reproduced in any manner without prior written permission from the publisher: Milkweed Editions, 1011 Washington Avenue South, Suite 300, Minneapolis, Minnesota 55415.</p>
<p class="CRT">(800) 520-6455</p>
<p class="CRT"><a href="http://milkweed.org/" target="_blank">milkweed.org</a></p>
<p class="CRT2">Published 2022 by Milkweed Editions</p>
<p class="CRT">Printed in the United States of America</p>
<p class="CRT">Cover design by Mary Austin Speaker</p>
<p class="CRT">22 23 24 25 26   5 4 3 2 1</p>
<p class="CRT"><i>First Edition</i></p>
<p class="CRT3">Library of Congress Cataloging-in-Publication Data</p>
<p class="CRT4">Names: Earling, Debra Magpie, author.</p>
<p class="CRT5">Title: Perma Red : a novel / Debra Magpie Earling.</p>
<p class="CRT5">Description: Minneapolis, Minnesota : Milkweed Editions, 2022. | Summary: “In 1940s western Montana on the Flathead Indian Reservation, Louise White Elk is determined to forge her own path despite the plans of three persistent men”-- Provided by publisher.</p>
<p class="CRT5">Identifiers: LCCN 2021057632 (print) | LCCN 2021057633 (ebook) | ISBN 9781571311467 (paperback) | ISBN 9781571317759 (ebook)</p>
<p class="CRT5">Subjects: LCSH: Salish Indians--Fiction. | Indian women--Fiction. | Flathead Indian Reservation (Mont.)--Fiction. | Montana--Fiction. | LCGFT: Novels.</p>
<p class="CRT5">Classification: LCC PS3605.A765 P47 2022 (print) | LCC PS3605. A765 (ebook) | DDC 813/.6--dc23/eng/20211129</p>
<p class="CRT5">LC record available at <a href="https://lccn.loc.gov/2021057632" target="_blank">https://lccn.loc.gov/2021057632</a></p>
<p class="CRT5">LC ebook record available at <a href="https://lccn.loc.gov/2021057633" target="_blank">https://lccn.loc.gov/2021057633</a></p>
<p class="CRT6">Milkweed Editions is committed to ecological stewardship. We strive to align our book production practices with this principle, and to reduce the impact of our operations in the environment. We are a member of the Green Press Initiative, a nonprofit coalition of publishers, manufacturers, and authors working to protect the world’s endangered forests and conserve natural resources. <i>Perma Red</i> was printed on acid-free 30% postconsumerwaste paper by Versa Press.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?49631486